import useFantasySelected from '@/DesignSystem/hooks/useFantasySelected';
import { Typography } from '@mui/material';
import { FANTASY } from '@/helpers/biwenger-helper';

export const getTierForPuntuacionFantasy = (estadisticaPartido, confirmedMode, confirmedFantasy) => {
    if (!estadisticaPartido) return null;

    const puntuacion = parseFloat(estadisticaPartido);
    const mode = confirmedMode ?? confirmedFantasy;

    // Rangos para La Liga Fantasy
    if (mode === FANTASY.FANTASY) {
        if (puntuacion < 3) return 6; // Tier 6
        if (puntuacion >= 3 && puntuacion <= 4) return 5; // Tier 5
        if (puntuacion >= 5 && puntuacion <= 6) return 4; // Tier 4
        if (puntuacion >= 7 && puntuacion <= 8) return 3; // Tier 3
        if (puntuacion > 8 && puntuacion <= 10) return 2; // Tier 2
        if (puntuacion > 10) return 1; // Tier 1
    }

    if (mode === FANTASY.FANTASY_MARCA) {
        if (puntuacion < 3) return 6; // Tier 6
        if (puntuacion >= 3 && puntuacion <= 4) return 5; // Tier 5
        if (puntuacion >= 5 && puntuacion <= 6) return 4; // Tier 4
        if (puntuacion >= 7 && puntuacion <= 8) return 3; // Tier 3
        if (puntuacion > 8 && puntuacion <= 10) return 2; // Tier 2
        if (puntuacion > 10) return 1; // Tier 1
    }

    if (mode === FANTASY.MISTER_FANTASY) {
        if (puntuacion < 3) return 6; // Tier 6
        if (puntuacion >= 3 && puntuacion <= 4) return 5; // Tier 5
        if (puntuacion >= 5 && puntuacion <= 6) return 4; // Tier 4
        if (puntuacion >= 7 && puntuacion <= 8) return 3; // Tier 3
        if (puntuacion > 8 && puntuacion <= 10) return 2; // Tier 2
        if (puntuacion > 10) return 1; // Tier 1
    }

    // Rangos para Biwenger
    if (mode === FANTASY.BIWENGER) {
        if (puntuacion < 3) return 6; // Tier 6
        if (puntuacion >= 3 && puntuacion <= 4) return 5; // Tier 5
        if (puntuacion >= 5 && puntuacion <= 6) return 4; // Tier 4
        if (puntuacion >= 7 && puntuacion <= 8) return 3; // Tier 3
        if (puntuacion > 8 && puntuacion <= 10) return 2; // Tier 2
        if (puntuacion > 10) return 1; // Tier 1
    }

    // Rangos para Analítica Fantasy
    if (mode === FANTASY.ANALITICA) {
        if (puntuacion < 6) return 6; // Tier 6
        if (puntuacion >= 6 && puntuacion < 6.5) return 5; // Tier 5
        if (puntuacion >= 6.5 && puntuacion < 7) return 4; // Tier 4
        if (puntuacion >= 7 && puntuacion < 7.5) return 3; // Tier 3
        if (puntuacion >= 7.5 && puntuacion < 8) return 2; // Tier 2
        if (puntuacion >= 8) return 1; // Tier 1
    }

    // Rangos por defecto (fallback)
    if (puntuacion >= 8) return 1; // Tier 1
    if (puntuacion >= 7) return 2; // Tier 2
    if (puntuacion >= 6) return 3; // Tier 3
    if (puntuacion >= 5) return 4; // Tier 4
    if (puntuacion >= 3) return 5; // Tier 5
    return 6; // Tier 6
};

const TierPuntuacionConfirmada = ({ estadisticaPartido, confirmedMode, fontSize = 12, ...props }) => {
    const { confirmedFantasy } = useFantasySelected();

    if (!estadisticaPartido) return null;

    const tier = getTierForPuntuacionFantasy(estadisticaPartido, confirmedMode, confirmedFantasy);

    if (!tier) return null;

    return (
        <Typography fontSize={fontSize} color="text.secondary" {...props}>
            Tier {tier}
        </Typography>
    );
};

export default TierPuntuacionConfirmada;
